import { Card, Flex, Steps, Tag, theme, Typography } from 'antd'
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { STEPS_CONFIG } from 'Pages/QuotationPage/constants/stepsConfig';
import { SUCCESS_COLOR } from '@shared/constants/colors';
import { ShareFormLink } from './ShareFormLink';
import { StepIcon } from './StepIcon';

const { Text } = Typography;

export const CreateQuotationRightSidebar = ({ currentStep }) => {
  const { token: themeToken } = theme.useToken();

  const items = STEPS_CONFIG.map(({ icon, title }, step) => {
    const isActive = currentStep === step;
    const isCompleted = currentStep > step;

    const titleColor = (
      isActive ? themeToken.colorPrimary :
        isCompleted ? SUCCESS_COLOR :
          'inherit'
    );

    const finalIcon = (
      isActive ? <StepIcon icon={icon} color={themeToken.colorPrimary} /> :
        isCompleted ? <StepIcon icon={faCheck} color={SUCCESS_COLOR} /> :
          null
    );

    return {
      title: <Text strong style={{ color: titleColor }}>{title}</Text>,
      icon: finalIcon,
    };
  });

  return (
    <Flex vertical gap={16} style={{ width: 320, maxWidth: '100%' }}>
      <Card>
        <Flex vertical gap={24}>
          <Tag
            color={themeToken.colorPrimary}
            style={{
              margin: 0,
              padding: '8px 16px',
              borderRadius: 8,
              fontSize: 'inherit',
              textAlign: 'center',
            }}
          >
            <Text strong style={{ color: 'inherit' }}>
              Ruta de cotización
            </Text>
          </Tag>
          <Steps
            direction='vertical'
            current={currentStep}
            items={items}
          />
        </Flex>
      </Card>
      <ShareFormLink />
    </Flex>
  );
};
